<script setup>

</script>

<template>
        <span class="loader" v-if="$store.getters.load">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                        </span>

</template>

<style scoped lang="scss">
.loader{
  position: fixed;
  bottom: 20px;
  right: 20px;
}
</style>